import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OroService } from '../../oroservice';

export interface DialogData {
    von: Date;
    bis: Date;
    id: number;
}

@Component({
    selector: 'app-dialog-absence',
    templateUrl: './dialog-absence.component.html',
    styleUrls: ['./dialog-absence.component.scss'],
    standalone: false
})
export class DialogAbsenceComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<DialogAbsenceComponent>, public oroservice: OroService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

    ngOnInit(): void {
    }

    hasError() {
        if (this.data.von && this.data.bis) {
            return (this.data.bis < this.data.von);
        }
        return false;
    }

    canSubmit() {
        return (this.data.von && this.data.bis && !this.hasError());
    }

    submit() {
        this.oroservice.addAbwesenheit(this.data).then(
            (object) => {
                if (object != null && object.status !== 400) {
                    this.dialogRef.close(true);
                }
            }
        );
    }

    getTitle() : string {
        return this.data.id === 0 ? "Startseite.AbwesenheitAdd" : "Startseite.AbwesenheitEdit";
    }
}
